var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 3.49596,
    fill: "#F5FFF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10.5345V9.5H14.5V10.5345C13.6201 10.6467 12.8023 11.0479 12.1751 11.6751C11.5479 12.3023 11.1467 13.1201 11.0345 14H10V15H11.0345C11.1466 15.8799 11.5478 16.6977 12.175 17.325C12.8023 17.9522 13.6201 18.3534 14.5 18.4655V19.5H15.5V18.4655C16.3799 18.3534 17.1977 17.9522 17.825 17.325C18.4522 16.6977 18.8534 15.8799 18.9655 15H20V14H18.9655C18.8533 13.1201 18.4521 12.3023 17.8249 11.6751C17.1977 11.0479 16.3799 10.6467 15.5 10.5345ZM15 17.5C13.3455 17.5 12 16.1545 12 14.5C12 12.8455 13.3455 11.5 15 11.5C16.6545 11.5 18 12.8455 18 14.5C18 16.1545 16.6545 17.5 15 17.5Z",
    fill: "#64C073"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.8173cc1c5ec10f7e73fba56221be9fb6.svg";
export { ForwardRef as ReactComponent };